module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"wrongwindows.rocks","icon":"src/assets/rast/WW_icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"f3939ae3435ba660c6700c84c6c88410"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
